import apiWrapper from './helpers';

export default class GCMFeeBalance extends apiWrapper('/gcm_fee_balances') {

}
